module.exports = __webpack_public_path__ + "quick-e80ab0c117609853bbca300c872bcb0b.png";